import IconRender from './IconRender';

export default IconRender;